var _defs, _rect, _rect2, _rect3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedCardLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ded3516843"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 112.5 112.5 L 262.5 112.5 L 262.5 262.5 L 112.5 262.5 Z M 112.5 112.5 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ded3516843)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0277b5",
    d: "M 249.96875 112.5 L 125.105469 112.5 C 118.203125 112.5 112.648438 118.128906 112.648438 124.957031 L 112.648438 250.042969 C 112.648438 256.945312 118.277344 262.5 125.105469 262.5 L 249.894531 262.5 C 256.796875 262.5 262.351562 256.871094 262.351562 250.042969 L 262.351562 124.957031 C 262.425781 118.128906 256.871094 112.5 249.96875 112.5 Z M 156.996094 236.238281 L 134.859375 236.238281 L 134.859375 169.753906 L 156.996094 169.753906 Z M 145.890625 161.722656 C 138.914062 161.722656 133.285156 156.097656 133.285156 149.117188 C 133.285156 142.140625 138.914062 136.511719 145.890625 136.511719 C 152.871094 136.511719 158.496094 142.140625 158.496094 149.117188 C 158.496094 156.097656 152.871094 161.722656 145.890625 161.722656 Z M 240.289062 236.238281 L 218.078125 236.238281 L 217.550781 196.765625 C 217.550781 196.765625 218.078125 186.261719 206.597656 186.335938 C 195.117188 186.410156 193.539062 196.765625 193.539062 196.765625 L 193.539062 236.238281 L 171.179688 236.238281 L 171.179688 169.753906 L 192.640625 169.753906 L 192.640625 178.90625 C 192.640625 178.90625 193.539062 175.90625 198.492188 172.378906 C 203.445312 168.851562 211.625 168.101562 215.152344 168.253906 C 218.679688 168.402344 223.480469 167.800781 231.507812 173.355469 C 240.140625 179.285156 240.363281 194.816406 240.363281 194.816406 Z M 240.289062 236.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedCardLogo);
export default __webpack_public_path__ + "static/media/linked-card-logo.3c722582efd9426db8f2b949521b41c6.svg";
export { ForwardRef as ReactComponent };